<div class="toast-container">
  @for (toast of toasts; track toast.id) {
    <app-toast-notification
      [message]="toast.message"
      [type]="toast.type"
      [duration]="toast.duration"
      (click)="removeToast(toast.id)">
    </app-toast-notification>
  }
</div>
